import { render } from "./ErrorPageBlock.vue?vue&type=template&id=5c99a88e"
import script from "./ErrorPageBlock.vue?vue&type=script&lang=js"
export * from "./ErrorPageBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__